import React, { useContext, useEffect, useState, useRef } from 'react';
import FroalaEditor from 'froala-editor';
import styled from '@emotion/styled';
import { useTheme } from '@chakra-ui/react';
import { useRecoilState } from 'recoil';
import { mediaAtom as _mediaAtom } from '../../state/media';
import { CloudinaryUploadContext } from '../../providers/CloudinaryProvider';
import { useSchemaQuery } from '../../react-apollo-introspection';
import 'froala-editor/js/plugins/paragraph_format.min.js';
/* eslint-disable */
const StyledContainer = styled.div`
  color: ${(props) => props.theme.colors.global.text};
  z-index: 1;
  position: relative;
  overscroll-behavior: contain;
  
  .fr-toolbar {
    background-color: rgba(0, 0, 0, 0.03);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    color: ${(props) => props.theme.colors.global.text};
    padding: 0px 0px;
    border: ${(props) => `1px solid ${props.theme.colors.gray['300']}`};
    z-index: 5000 !important;
    position: sticky;
    top: 0;
    background: ${(props) => props.theme.colors.global.elementBg || 'white'};
    
    .fr-newline {
      background-color: transparent;
    }
    
    .fr-btn-grp {
      margin-left: 0px;
    }
    
    .fr-command.fr-btn {
      margin: 0;
      color: ${(props) => props.theme.colors.global.text};
      
      &:hover {
        background-color: ${(props) => props.theme.colors.global.elementBg};
      }
      
      svg {
        height: 20px;
      }
      
      &.fr-active svg path {
        fill: ${(props) => props.theme.colors.secondary};
      }
      
      &:not(.fr-active) svg path {
        fill: ${(props) => props.theme.colors.global.text};
      }
      
      &.fr-btn-active-popup {
        background: ${(props) => props.theme.colors.secondary};
        
        svg path {
          fill: white;
        }
      }
    }
  }
  
  .fr-second-toolbar #fr-logo {
    display: none;
  }
  
  .fr-second-toolbar .fr-counter {
    font-size: 12px;
    padding-top: 3px;
  }
  
  .fr-popup {
    background-color: ${(props) => props.theme.colors.global.elementBgAlt};
    color: ${(props) => props.theme.colors.gray['400']};
    z-index: 9999;
    
    .fr-buttons {
      background-color: ${(props) => props.theme.colors.global.elementBgAlt};
    }
    
    .fr-input-line {
      padding: 8px 0px;
      
      label {
        top: 23px;
        background: transparent;
        color: ${(props) => props.theme.colors.gray['400']};
      }
      
      input {
        background: ${(props) => props.theme.colors.whiteAlpha[100]};
        border-color: ${(props) => props.theme.colors.gray['400']};
        color: ${(props) => props.theme.colors.gray['400']};
        border-width: 1px;
        padding-bottom: 0px;
        padding-top: 6px;
        
        &:focus {
          border-color: ${(props) => props.theme.colors.primary};
          border-width: 1px;
        }
      }
    }
    
    .fr-checkbox input:checked + span {
      background: ${(props) => props.theme.colors.primary};
      border-color: ${(props) => props.theme.colors.primary};
      
      svg path {
        fill: white;
      }
    }
  }
  
  .fr-box {
    .fr-wrapper {
      max-height: 750px !important;
      overflow-y: auto !important;
      overflow-x: hidden;
      overscroll-behavior: contain;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      background: ${(props) => props.theme.colors.richText.editorBg};
      color: ${(props) => props.theme.colors.global.text};
      border: ${(props) => `1px solid ${props.theme.colors.gray['300']}`};
      cursor: text;
      scroll-behavior: smooth;
    }
    
    .fr-element {
      color: ${(props) => props.theme.colors.global.text};
      padding: 7px 10px;
      min-height: 100px;
      
      a {
        text-decoration: underline;
        color: ${(props) => props.theme.colors.secondary};
      }
    }
    
    .fr-placeholder {
      color: ${(props) => props.theme.colors.gray[500]};
      opacity: 0.9;
    }
  }
  
  #froala-editor-p {
    border: 1px solid #0000ff;
  }
  
  .da-Froala p::after {
    content: '\\00B6';
    color: #6495ed;
    opacity: 0.9;
  }
  
  .da-Froala br {
    content: ' ';
  }
  
  .da-Froala br::after {
    content: '\\21b5\\000a';
    color: #6495ed;
    white-space: pre;
  }
`;
const RichTextEditor = ({
  onChange,
  value,
  placeholder,
  maxCharacters,
  name,
}) => {
  const theme = useTheme();
  const { show } = useContext(CloudinaryUploadContext);
  const [mediaAtom, setMediaAtom] = useRecoilState(_mediaAtom);
  const [editor, setEditor] = useState(null);
  const [ready, setReady] = useState(false);
  const [froalaEditor, setFroalaEditor] = useState(null);
  useEffect(() => {
    if (value) {
      setReady(true);
      setEditor(value);
    } else {
      setReady(true);
      setEditor(null);
    }
  }, [value]);
  useEffect(() => {
    // FroalaEditor.DefineIcon('insertHTML', { NAME: 'plus', SVG_KEY: 'add' });
    // FroalaEditor.RegisterCommand('insertHTML', {
    //   title: 'Insert HTML',
    //   focus: true,
    //   undo: true,
    //   refreshAfterCallback: true,
    //   callback: function() {
    //     this.html.insert('Some Custom HTML.');
    //     this.undo.saveStep();
    //   },
    // });
    FroalaEditor.DefineIcon('cloudinaryImage', {
      NAME: 'Insert Image',
      SVG_KEY: 'insertImage',
    });
    FroalaEditor.RegisterCommand('cloudinaryImage', {
      title: 'Upload Image',
      focus: false,
      undo: false,
      refreshAfterCallback: false,
      callback: function() {
        show(localStorage.getItem('activeMediaField'));
      },
    });
    FroalaEditor.RegisterCommand('insertCloudinaryImage', {
      title: 'Upload Image',
      focus: false,
      undo: false,
      refreshAfterCallback: false,
      callback: function() {
        const field = mediaAtom.find(
          (f) => f.name === localStorage.getItem('activeMediaField')
        );
        if (field && localStorage.getItem('activeMediaField') === name) {
          froalaEditor.image.insert(field.files[0].url, null, null, null);
        }
      },
    });
  }, [show]);
  const fEditor = useRef();
  const [call, { data: uploadData, called }] = useSchemaQuery(
    'bunnyFile_GetUploadData',
    {
      variables: {
        storagePath: '/nuclues-uploads',
      },
      fetchPolicy: 'network-only',
    }
  );
  const [callVideo, { data: videoData, called: calledVideo }] = useSchemaQuery("bunnyFile_GetVideoUploadData");
  useEffect(() => {
    if (ready) {
      var _editor = new FroalaEditor(
        fEditor.current,
        {
          heightMax: 750, // Maximum height (enables scrolling)
          scrollableContainer: 'body',
          editorClass: 'da-Froala',
          toolbarButtons: [
            [
              'paragraphFormat',  // Added heading/paragraph dropdown
              'undo',
              'redo',
              'copy',
              'cut',
              'paste',
              'bold',
              'italic',
              'underline',
              'align',
              'fontSize',
              'textColor',
              'subscript',
              'superscript',
            ],
            [
              'insertLink',
              process.env.REACT_APP_UPLOAD_METHOD !== 'cloudinary'
                ? 'insertImage'
                : 'cloudinaryImage',
              'insertVideo',
              'insertTable',
              'emoticons',
              'specialCharacters',
              'html',
            ],
            ['formatOL', 'formatUL'],
          ],
          // Configure which paragraph formats to show
          paragraphFormat: {
            N: 'Normal',
            H1: 'Heading 1',
            H2: 'Heading 2',
            H3: 'Heading 3',
            H4: 'Heading 4',
            H5: 'Heading 5',
            H6: 'Heading 6',
            PRE: 'Code'
          },
          // Set default paragraph format
          paragraphFormatSelection: true,
        
          // Optional: Set default paragraph format
          paragraphDefaultSelection: 'Normal',
          key: process.env.REACT_APP_FROALA_KEY,
          maxCharacters: maxCharacters ? maxCharacters : 999999,
          htmlAllowedEmptyTags: [
            'textarea',
            'a',
            'iframe',
            'object',
            'video',
            'style',
            '.fa',
          ],
          colorsText: [
            '#009688', // Brand Color
            '#B7342D', // Eat
            '#42AE99', // Sleep
            '#8A2BE2', // Drink
            '#FF8847', // Days Out
            '#42A6DF', // Feel the Experience,
            '#333333', // Text
            '#FFFFFF', // White
            '#000000'  // Black
          ],
          charCounterMax: maxCharacters ? maxCharacters : -1,
          placeholderText: placeholder,
          videoUpload: true,
          videoInsertButtons: ['videoBack', '|', 'videoByURL', 'videoUpload'], 
          videoAllowedTypes: ['mp4', 'webm', 'ogg', 'm3u8'], // allow direct files
          videoDefaultWidth: 600,
          toolbarInline: false,
          toolbarSticky: false,
          listAdvancedTypes: true,
          pastePlain: false,
          pasteDeniedTags: ['script', 'iframe', 'object', 'embed', 'form'],
          pasteDeniedAttrs: ['onclick', 'onload', 'onerror'],
          fontSize: [
            '8',
            '9',
            '10',
            '11',
            '12',
            '14',
            '16',
            '18',
            '20',
            '22',
            '24',
            '30',
            '36',
            '48',
            '60',
            '72',
            '96'
          ],
          fontSizeDefaultSelection: '18',
          events: {
            blur: function() {
              onChange(this.html.get());
            },
            contentChanged: function() {
              onChange(this.html.get());
            },
            // Custom event to override the default video insert behavior
            'video.beforeInsert': function (videoUrl) {
              // Prevent Froala from inserting its default iframe
              return false;
            },
            'commands.after': function (cmd) {
              if (cmd === 'videoInsertByURL') {
                setTimeout(() => {
                  let videoInput = document.querySelector('.fr-video-by-url-layer input');
                  let videoUrl = videoInput ? videoInput.value.trim() : '';
                  if (videoUrl) {
                    // Ensure it's a valid video URL
                    if (!videoUrl.match(/\.(mp4|webm|ogg)$/i)) {
                      return;
                    }
                    let videoTag = `
                      <span class="fr-video fr-deletable fr-fvc fr-dvb fr-draggable" contenteditable="false" draggable="true">
                        <video controls style="width: 100%; max-width: 800px; height: auto; aspect-ratio: 16/9;">
                          <source src="${videoUrl}" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>
                      </span>
                    `;
                    // Insert the custom <video> tag
                    this.html.insert(videoTag, true);
                    // **Close the popup manually**
                    this.popups.hide('video.insert');
                    // **Clear the input field to prevent reusing the old value**
                    videoInput.value = '';
                  }
                }, 100); // Delay for input value capture
              }
            },
            // **Handle the error message suppression**
            'video.error': function () {
              // Override default error handling and return false to suppress error messages
              return false;
            },
            'image.beforeUpload': function(images) {
              // Before image is uploaded
              const data = new FormData();
              data.append('file', images[0]);
              // const handleFileChange = (e) => {
              // setSelectedFile(e.target.files[0]);
              // setIsLoaded(false);
              call().then((res) => {
                // setBunnyData(res.data);
                var requestOptions = {
                  method: 'POST',
                  redirect: 'follow',
                  headers: res.data.bunnyFile_GetUploadData?.headers,
                  body: data,
                };
                fetch(
                  res.data.bunnyFile_GetUploadData?.uploadUrl,
                  requestOptions,
                  {
                    onError: function(error) {},
                    onSuccess: function() {},
                  }
                )
                  .then((response) => {
                    return response.json();
                  })
                  .then((result) => {
                    console.log('!!!!! data great?', result);
                    this.image.insert(
                      result.imageUrl,
                      null,
                      null,
                      this.image.get()
                    );
                  })
                  .catch((error) => console.log('!!!!! data  error', error));
              });
              return false;
              // };
            },
            "video.beforeUpload": function (files) {
              if (!files.length) return false;
              const editor = this;
              const file = files[0];
              // Insert placeholder while uploading
              const placeholderId = "video-loading-" + Date.now();
              editor.html.insert(
                `<div id="${placeholderId}" class="fr-uploading" style="text-align:center;padding:20px;">
                  Uploading video…
                </div>`
              );
              // 1️⃣ Call BunnyFile GraphQL query to get upload URL + headers
              callVideo({
                variables: {
                  useFileName: false,
                  bulk: false,
                  path: "/nuclues-uploads/videos"
                }
              }).then(res => {
                editor.popups.hide('video.insert');
                const { uploadUrl, headers } = res.data?.bunnyFile_GetVideoUploadData || {};
                if (!uploadUrl) {
                  editor.$el.find('#' + placeholderId).replaceWith('<p style="color:red;">Failed to get Bunny upload URL.</p>');
                  return;
                }
                // 2️⃣ Build FormData
                const formData = new FormData();
                formData.append("file", file);
                // 3️⃣ Upload to Bunny
                fetch(uploadUrl, {
                  method: "POST",
                  headers,
                  body: formData
                })
                .then(r => r.json())
                .then(result => {
                  // Remove loader
                  const $ph = editor.$el.find('#' + placeholderId);
                  if ($ph.length) $ph.remove();
                  if (!result?.imageUrl) {
                    editor.html.insert('<p style="color:red;">Upload failed.</p>');
                    return;
                  }
                  const videoUrl = result.imageUrl;
                  // 4️⃣ Insert video into Froala
                  const id = 'frv-' + Date.now();
                  const html = `
                    <span id="${id}" class="fr-video fr-deletable fr-draggable" contenteditable="false">
                      <video controls style="width: 100%; max-width: 800px; height: auto; aspect-ratio: 16/9;">
                        <source src="${videoUrl}" type="video/mp4"/>
                      </video>
                    </span>
                  `;
                  editor.html.insert(html);
                  // Trigger Froala's bindings
                  const $wrap = editor.$el.find('#' + id);
                  if ($wrap.length) {
                    editor.selection.setAfter($wrap[0]);
                    editor.events.trigger('video.inserted', [$wrap]);
                  }
                 
                })
                .catch(err => {
                  console.error('Bunny upload error:', err);
                  const $ph = editor.$el.find('#' + placeholderId);
                  if ($ph.length) $ph.replaceWith('<p style="color:red;">Upload failed.</p>');
                });
              });
              return false;
            },
          },
        },
        function() {
          _editor.html.set(editor);
        }
      );
      setFroalaEditor(_editor);
    }
    return () => {
      if (editor) {
        _editor.destroy();
        setFroalaEditor(null);
      }
    };
  }, [ready]);
  useEffect(() => {
    const field = mediaAtom.find(
      (f) => f.name === localStorage.getItem('activeMediaField')
    );
    if (field && field.files.length !== 0) {
      FroalaEditor.COMMANDS.insertCloudinaryImage.callback.call();
    }
  }, [mediaAtom]);
  return (
    <StyledContainer
      theme={theme}
      onClick={() => localStorage.setItem('activeMediaField', name)}
    >
      <textarea ref={fEditor} onChange={(e) => setEditor(e.target.value)}>
        {editor}
      </textarea>
    </StyledContainer>
  );
};
export default RichTextEditor;